import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=b8605f90&scoped=true"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"
import style0 from "./HomeLayout.vue?vue&type=style&index=0&id=b8605f90&prod&lang=css"
import style1 from "./HomeLayout.vue?vue&type=style&index=1&id=b8605f90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8605f90",
  null
  
)

export default component.exports